<template>
  <div class="personnel-on-duty-classes-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班次名称：</span>
        </div>
        <el-input v-model="formData.routeName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">班次描述：</span>
        </div>
        <el-input v-model="formData.description" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班次时间：</span>
        </div>
        <time-interval @getAttendanceItemDurations="getTimeArr" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">班次备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import md5 from 'js-md5'
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../../components/Text/TextTitle'
import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../../components/Button/ButtonCancel'
import {api} from '../../../api/ParkingService'
import {errorHandler} from '../../../../utils/errorHandler'
import {nError, nSuccess} from '../../../../utils/notice'
import {pattern} from '../../../../utils/regular'
import TimeInterval from "../../../../components/WeekTime/timeInterval";

export default {
  components: {
    TimeInterval,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'personnel-on-duty-classes-add',
  data () {
    return {
      breadcrumb: [
        {value: '智慧停车', name: 'parking-device-management'},
        {value: '班次管理'}
      ],
      mainTitle: '添加班次',
      subheading: '',

      formData: {
        routeName: '',
        description: '',
        monTimes: [],
        tueTimes: [],
        wedTimes: [],
        thuTimes: [],
        friTimes: [],
        satTimes: [],
        sunTimes: [],
        memo: '',
      }
    }
  },
  created () {
  },
  methods: {

    toMangePage () {
      this.$router.push({
        name: 'personnel-on-duty-classes-manage'
      })
    },

    getTimeArr (data) {
      this.formData.monTimes = []
      this.formData.tueTimes = []
      this.formData.wedTimes = []
      this.formData.thuTimes = []
      this.formData.friTimes = []
      this.formData.satTimes = []
      this.formData.sunTimes = []
      data.map(v => {
        if (v.weekDay.length > 0) {
          v.weekDay.map(weekDay => {
            if (weekDay === '周一') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.monTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.monTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周二') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.tueTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.tueTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周三') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.wedTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.wedTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周四') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.thuTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.thuTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周五') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.friTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.friTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周六') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.satTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.satTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周日') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.sunTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.sunTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
          })
        }
      })
    },

    // 确认添加
    confirm () {
      this.$axios.post(api.addParkingEmergencyRoute, this.formData)
        .then(res => {
          nSuccess('添加成功')
          this.toMangePage()
        })
        .catch(errorHandler('添加失败'))
    },
    cancel () {
      this.toMangePage()
    }
  },
  watch: {}
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
}
.form-line {
  margin: 20px 0;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/PersonnelOnDuty/PersonnelOnDutyClasses/PersonnelOnDutyClassesAdd.vue